import { gql } from '@lcs/shared/api';

export const deleteCallRecordingMutation = gql`
   mutation DeleteCallRecording($callRecordingId: UInt!) {
      deleteCallRecording(id: $callRecordingId)
   }
`;
